import { OutOfStockMessages } from '../constant/constant';
import { OutOfStockOverlayProps, OutOfStock } from '../interface/interface';

/**
 * OutOfStockOverlay component displays an overlay with a message when a product is out of stock.
 *
 * @param {OutOfStockOverlayProps} props - The properties for the component.
 * @param {OutOfStock} props.outOfStock - The out of stock status of the product.
 * @param {number} props.inventoryQuantity - The available inventory quantity of the product.
 *
 * @returns {JSX.Element} The JSX element representing the out of stock overlay.
 *
 * @example
 * <OutOfStockOverlay outOfStock={OutOfStock.quantityZero} inventoryQuantity={0} />
 */
const OutOfStockOverlay = (props: OutOfStockOverlayProps): JSX.Element => {
  const {
    outOfStock,
    inventoryQuantity,
    hasSubstitute = false,
    isGuest = false,
  } = props;
  return outOfStock === OutOfStock.false ? (
    <></>
  ) : (
    <>
      <div className="w-[95%] md:w-full h-full flex z-10 absolute top-0 left-0 justify-center items-center bg-white opacity-50"></div>
      <div className="w-full h-full flex z-20 absolute top-0 left-0 justify-center items-center bg-transparent">
        <span className="text-black text-sm w-6/7 font-semibold text-center select-text italic whitespace-pre-line" data-testid='out-of-stock-overlay-message'>
          {outOfStock === OutOfStock.quantityZero &&
            hasSubstitute &&
            OutOfStockMessages.QuantityZero}
          {outOfStock === OutOfStock.quantityZero &&
            !hasSubstitute &&
            !isGuest &&
            OutOfStockMessages.QuantityZero}
          {outOfStock === OutOfStock.orderedQuantityExceeds &&
            OutOfStockMessages.OrderQuantityExceeds(inventoryQuantity)}
          {outOfStock === OutOfStock.withNoSubs && OutOfStockMessages.NoSubs}
          {outOfStock === OutOfStock.withNoDoctorApprovedSub &&
            OutOfStockMessages.NoSubs}
          {outOfStock === OutOfStock.orderedQuantityExceedsWithNoSubs &&
            OutOfStockMessages.OrderQuantityExceeds(inventoryQuantity)}
        </span>
      </div>
    </>
  );
};

export default OutOfStockOverlay;
